var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 21.5V15.975C4.31667 15.8417 2.89583 15.1583 1.7375 13.925C0.579167 12.6917 0 11.2167 0 9.5C0 7.68333 0.629167 6.14583 1.8875 4.8875C3.14583 3.62917 4.68333 3 6.5 3H7.175L5.6 1.4L7 0L11 4L7 8L5.6 6.6L7.175 5H6.5C5.25 5 4.1875 5.4375 3.3125 6.3125C2.4375 7.1875 2 8.25 2 9.5C2 10.75 2.4375 11.8125 3.3125 12.6875C4.1875 13.5625 5.25 14 6.5 14H8V16.675L10.675 14H13.5C14.75 14 15.8125 13.5625 16.6875 12.6875C17.5625 11.8125 18 10.75 18 9.5C18 8.25 17.5625 7.1875 16.6875 6.3125C15.8125 5.4375 14.75 5 13.5 5H13V3H13.5C15.3167 3 16.8542 3.62917 18.1125 4.8875C19.3708 6.14583 20 7.68333 20 9.5C20 11.3167 19.3708 12.8542 18.1125 14.1125C16.8542 15.3708 15.3167 16 13.5 16H11.5L6 21.5Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickType);
export default __webpack_public_path__ + "static/media/quickType.8816f1fecd6b4024b37e27a13247e504.svg";
export { ForwardRef as ReactComponent };